/** Обложки топ-категорий (файлы в public/images) */
export const CAT_IMAGE_MAP = {
  'душевые-программы': '/images/dush2.jpg',
  'душевые-кабины-и-ограждения': '/images/dush.jpg',
  'смесители': '/images/cover.jpg',
  'керамика': '/images/keram.jpg',
  'ванны': '/images/vanna.jpg',
  'кухонные-мойки': '/images/rakovin.jpg',
  'полотенцесушители': '/images/polotenc.jpeg',
  'инсталляции': '/images/install.jpg',
  'аксессуары': '/images/uyut_acc_1.jpg',
  'слив-и-канализация': '/images/sliv.jpg',
};

export function categoryCover(slug) {
  return CAT_IMAGE_MAP[slug] || `/images/${slug}.jpg`;
}
